<template>
  <div class="container">
    <Winners/>
    <div class="direction-column">
      <AmusnetJackpot v-if="!isMobile"></AmusnetJackpot>
     
    <div class="content-area popular">
      <div class="t">
        <div class="row">
          <div class="col" v-for="item in eventGames">
              <router-link :to="'/' + item.url">
                <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
              </router-link>
          </div>
        </div>
      </div>
    </div>
    
        
    <div class="home-navs navigator">
      <router-link to="/sportsbook">
        <img src="@/assets/images/homepage/abanners/sports.png" width="100%">
        SPOR
      </router-link>
      <router-link to="/slot">
        <img src="@/assets/images/homepage/abanners/slots.png" width="100%">
        SLOT
      </router-link>
      <router-link to="/casino">
        <img src="@/assets/images/homepage/abanners/casino(2).png" width="100%">
        CASINO
      </router-link>
      <router-link to="/virtual">
        <img src="@/assets/images/homepage/abanners/sanal.png" width="100%">
        SANAL
      </router-link>
      <router-link to="/highfilyer">
        <img src="@/assets/images/homepage/abanners/highflyer.png" width="100%">
        HIGH FLYER
      </router-link>
      <router-link to="/zeppelin">
        <img src="@/assets/images/homepage/abanners/zeplin.png" width="100%">
        ZEPLİN
      </router-link>
      <router-link to="/aviator">
        <img src="@/assets/images/homepage/abanners/aviator.png" width="100%">
        AVIATOR
      </router-link>
      <router-link to="/slot/smartsoft/all?game_id=75340&mobile=false">
        <img src="@/assets/images/homepage/abanners/jetX.png" width="100%">
        JETX
      </router-link>
    </div>
    <!-- <div class="home-navs navigator" v-if="isMobile">
      <router-link style="width: 16% !important;" to="/slot">
        <img src="@/assets/images/homepage/banners2/2.png" width="100%">
        MİLYONER
      </router-link>
      <a style="width: 16% !important;" href="https://api.mersobahis.pro/ara/">
        <img src="@/assets/images/homepage/banners2/4.png" width="100%">
        BENİ ARA
      </a>
      <a style="width: 16% !important;" href="https://api.mersobahis.pro/mobile-app/">
        <img src="@/assets/images/homepage/banners2/5.png" width="100%">
        MOBİL APP
      </a>
      <a style="width: 16% !important;" href="hhttps://api.mersobahis.pro/wheel/?username=%7B%7Busername%7D%7D">
        <img src="@/assets/images/homepage/banners2/3.png" width="100%">
        ŞANS ÇARKI
      </a>
      <router-link style="width: 16% !important;"  to="/affiliate">
        <img src="@/assets/images/homepage/banners2/1.png" width="100%">
        ORTAKLIK
      </router-link>
    </div> -->
    <AmusnetJackpot v-if="isMobile"></AmusnetJackpot>
    <div class="content-area">
      <div class="top">
        <div class="icon">
          <svg fill="currentColor" enable-background="new 0 0 64 64" viewBox="0 0 64 64"><path d="m8.55047 39.62875-3.25125 10.00953c-3.09766-4.65906-4.99203-10.21438-5.24797-16.17906zm12.18547-37.58078c-5.45282 2.04797-10.21438 5.55516-13.77281 10.03516h10.52172zm-1.58719 32.76797 4.09609-12.64641-5.47844-7.52641h-12.6464c-2.94406 4.55688-4.78719 9.90719-5.06875 15.66719l10.21437 7.39844zm11.54562 10.26562-10.77765-7.80797-8.8575 2.89281-3.91688 12.00641c3.50719 4.27515 8.06406 7.65437 13.31203 9.67672l10.24-7.42391zm-7.24484 17.76641c2.71359.74234 5.58094 1.15203 8.55047 1.15203 2.94406 0 5.81125-.40969 8.49922-1.15203l-8.52484-6.19516zm2.15047-39.60328-3.94234 12.1089 10.31672 7.50078 10.31687-7.50078-3.9425-12.1089zm-.28156-2.56h13.31203l5.47828-7.55187-3.91672-12.08329c-2.61125-.69125-5.35047-1.04953-8.19203-1.04953s-5.60641.38391-8.24328 1.07516l-3.91672 12.05765zm18.68796 16.5889-10.75203 7.80797v9.34406l10.24 7.44953c5.24797-2.02234 9.80484-5.37594 13.31203-9.65125l-3.94234-12.08313zm13.03032-25.19046c-3.58391-4.50563-8.37109-8.01282-13.84953-10.06079l3.25125 10.06078h10.59828zm-16.35828 10.11203 4.12156 12.6464 8.85766 2.86719 10.29109-7.44953c-.30719-5.73453-2.12469-11.08484-5.06875-15.61609h-12.69766zm17.99672 27.49437c3.12328-4.68484 5.04328-10.26562 5.27359-16.28156l-8.55031 6.22078z"></path></svg>
        </div>
        <div class="text">
          <p>
            <router-link to="/sportsbook">SPORUN YILDIZLARI</router-link>
            </p>
          <span>Spor'un yıldızları Mersobahis'de seni bekliyor!</span>
        </div>
      </div>
      <div class="t">
        <div class="row">
          <div class="col">
            <router-link to="/sportsbook">
              <img src="@/assets/images/homepage/sport/sports.png" width="100%">
            </router-link>
          </div>
          <div class="col">
            <router-link to="/sportsbook">
              <img src="@/assets/images/homepage/sport/basketbol.png" width="100%">
            </router-link>
          </div>
          <div class="col">
            <router-link to="/sportsbook">
              <img src="@/assets/images/homepage/sport/cs.png" width="100%">
            </router-link>
          </div>
          <div class="col">
            <router-link to="/sportsbook">
              <img src="@/assets/images/homepage/sport/golf.png" width="100%">
            </router-link>
          </div>
          <div class="col">
            <router-link to="/sportsbook">
              <img src="@/assets/images/homepage/sport/formula1.png" width="100%">
            </router-link>
          </div>
          <div class="col">
            <router-link to="/sportsbook">
              <img src="@/assets/images/homepage/sport/mma.png" width="100%">
            </router-link>
          </div>
          <div class="col">
            <router-link to="/sportsbook">
              <img src="@/assets/images/homepage/sport/tenis.png" width="100%">
            </router-link>
          </div>
          <div class="col">
            <router-link to="/sportsbook">
              <img src="@/assets/images/homepage/sport/voleybol.png" width="100%">
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="content-area">
      <div class="top">
        <div class="icon">
          <svg fill="currentColor" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><path d="m352.359 169.863-104.137 298.316-.222.267-.225-.271-104.115-298.312zm-219.703-31.528 83.291-94.781h-116.371zm205.387 7.531-89.934-102.312h-.217l-89.909 102.312zm58.408-102.312h-116.391l83.307 94.774zm-286.584 102.312-31.549-90.395-77.938 90.395zm267.908 23.997-85.71 245.53 203.935-245.53zm8.377-23.997h109.472l-77.916-90.397zm-267.909 23.997h-118.243l203.938 245.534z"></path></svg>
        </div>
        <div class="text">
          <p>
            <router-link to="/slot">SLOT OYUNLARI</router-link>
          </p>
          <span>Pragmatic Play, Amusnet, EGT ve daha fazlası.</span>
        </div>
      </div>
      <div class="t">
        <div class="row">
          <div class="col" v-for="item in slotGames">
              <router-link :to="'/' + item.url">
                <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
              </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="content-area">
      <div class="top">
        <div class="icon">
          <svg fill="currentColor" enable-background="new 0 0 511.106 511.106" height="512" viewBox="0 0 511.106 511.106" width="512"><g><path d="m426.631 174.102c9.758 20.412 15.969 42.828 17.827 66.451h66.648c-2.019-35.176-11.111-69.016-26.621-99.854z"></path><path d="m99.717 147.868c13.091-18.886 29.52-35.287 48.431-48.345l-33.4-57.851c-14.32 9.469-27.796 20.443-40.215 32.862-11.295 11.295-21.388 23.469-30.25 36.353z"></path><path d="m148.149 411.583c-19.005-13.123-35.503-29.621-48.626-48.626l-57.851 33.4c9.469 14.32 20.443 27.796 32.862 40.215 12.418 12.418 25.895 23.392 40.215 32.862z"></path><path d="m411.583 362.958c-13.123 19.005-29.621 35.503-48.626 48.625l33.401 57.851c14.32-9.469 27.796-20.443 40.214-32.861s23.392-25.895 32.862-40.215z"></path><path d="m84.475 337.004c-9.758-20.412-15.969-42.828-17.827-66.451h-66.648c2.019 35.176 11.111 69.016 26.621 99.854z"></path><path d="m337.004 426.63c-20.412 9.758-42.829 15.969-66.451 17.827v66.648c35.177-2.019 69.016-11.112 99.854-26.621z"></path><path d="m444.458 270.553c-1.859 23.623-8.07 46.04-17.827 66.451l57.855 33.402c15.509-30.838 24.601-64.677 26.62-99.854h-66.648z"></path><path d="m240.553 444.458c-23.623-1.859-46.039-8.07-66.451-17.827l-33.403 57.855c30.838 15.509 64.677 24.601 99.854 26.621z"></path><path d="m270.553 66.648c23.623 1.859 46.039 8.07 66.451 17.827l33.403-57.855c-30.838-15.508-64.678-24.601-99.854-26.62z"></path><path d="m362.957 99.523c19.005 13.123 35.504 29.621 48.626 48.626l57.851-33.4c-9.469-14.32-20.443-27.796-32.862-40.215-12.419-12.418-25.895-23.392-40.215-32.862z"></path><path d="m174.102 84.475c20.412-9.757 42.828-15.968 66.451-17.827v-66.648c-35.177 2.019-69.016 11.112-99.854 26.621z"></path><path d="m66.648 240.553c1.867-23.722 8.12-46.229 17.948-66.71l-55.845-37.256c-16.799 31.933-26.642 67.217-28.751 103.966z"></path><path d="m255.553 96.055c-87.947 0-159.498 71.55-159.498 159.498s71.551 159.498 159.498 159.498 159.498-71.55 159.498-159.498-71.551-159.498-159.498-159.498zm59.615 159.498c0 10.793-2.857 21.144-8.199 30.203l34.785 34.785c5.858 5.857 5.858 15.355 0 21.213-2.929 2.929-6.768 4.394-10.606 4.394s-7.678-1.464-10.606-4.394l-34.785-34.785c-9.059 5.342-19.41 8.2-30.203 8.2s-21.145-2.857-30.203-8.2l-34.785 34.785c-2.929 2.929-6.769 4.394-10.606 4.394-3.839 0-7.678-1.464-10.606-4.394-5.858-5.858-5.858-15.355 0-21.213l34.785-34.785c-5.342-9.059-8.199-19.41-8.199-30.203s2.857-21.144 8.199-30.203l-34.785-34.785c-5.858-5.857-5.858-15.355 0-21.213 5.857-5.858 15.355-5.858 21.213 0l34.785 34.785c9.059-5.342 19.41-8.2 30.203-8.2s21.145 2.857 30.203 8.2l34.785-34.785c5.857-5.858 15.355-5.857 21.213 0 5.858 5.858 5.858 15.355 0 21.213l-34.785 34.785c5.34 9.059 8.197 19.41 8.197 30.203z"></path><path d="m255.553 225.951c-7.584 0-15.168 2.887-20.941 8.66-5.594 5.594-8.674 13.031-8.674 20.941s3.08 15.348 8.674 20.941c11.547 11.547 30.336 11.547 41.883 0 5.594-5.594 8.674-13.031 8.674-20.941s-3.08-15.348-8.674-20.941c-5.774-5.773-13.358-8.66-20.942-8.66z"></path></g></svg>
        </div>
        <div class="text">
          <p>
            <router-link to="/casino">CANLI CASINO OYUNLARI</router-link>
          </p>
          <span>En çok kazandıran canlı casino oyunları...</span>
        </div>
      </div>
      <div class="t">
        <div class="row">
          <div class="col" v-for="item in casinoGames">
              <router-link :to="'/' + item.url">
                <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
              </router-link>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import Jackpot from '../Common/Jackpot'
  import Game from '../Casino/Game'
  import AmusnetJackpot from '../../components/Slot/AmusnetJackpot';
  import Winners from '../../components/Common/Winners';
  import UserLogin from '../../views/Auth/Login'
import { isMobile } from 'mobile-device-detect';
  export default {
    components:{
      Game,
      UserLogin,
      Winners,
      AmusnetJackpot,
      Jackpot
    },
    data() {
      return {
        eventSlider:[],
        animate:true,
        partners:[],
        lastWinners:[],
        loginModal: false,
        isLoading: false,
        swiperOption: {
					lazy: true,
					speed: 1500,
          slidesPerView: 3,
          autoplay: {
            delay: 2000,
					},
          // effect: 'fade',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        swiperOptionWinners: {
					lazy: true,
					speed: 1500,
          slidesPerView: 4,
          autoplay: {
            delay: 2000,
					},
          // effect: 'fade',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        crashGames:[
        ],
        eventGames:[
        ],
        casinoGames:[
        ],
        slotGames:[
        ]
      }
    },
    created(){
      this.fetchData();
      setTimeout(() => {
        this.animate = false
      }, 2000);
      setInterval(() => {
        this.animate = true;
          setTimeout(() => {
            this.animate = false
          }, 2000);
      }, 5000);
    },
    methods:{
      fetchData: function() {
          if(this.isMobile){
            this.swiperOption.slidesPerView = 1
            this.swiperOptionWinners.slidesPerView = 2;
          }
          this.isLoading = true,
          this.$store.dispatch('getBanner', ['home', 'both', 'bottom'])
          .then(response =>{
            this.crashGames = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'single'])
          .then(response =>{
            this.partners = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'left'])
          .then(response =>{
            this.slotGames = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'right'])
          .then(response =>{
            this.casinoGames = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
          this.$store.dispatch('getBanner', ['home', 'both', 'top'])
          .then(response =>{
            this.eventGames = _.sortBy(response.data, ['sort'])
            this.isLoading = false;
          });
      },
      open(provider, id, route){
        let routeData = this.$router.resolve({ name: route, params: { provider: provider, category : 'all' }, query: { game_id: id, mobile: this.isMobile }});
        if(!this.$auth()){
          this.loginModal = true
          return false;
        }else{
          window.location.href = routeData.href;
        }
      },
    },
    computed:{
      egt_show(){
        if(this.locale == 'TR' && this.user && this.user.balance > 0){
          return true
        }else{
          return false
        }
      },
      client_id(){
        return process.env.VUE_APP_CLIENT_ID
      },
      user(){
        return this.$user();
      },
      cdn_url(){
        return this.$store.getters['getCdnUrl'];
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      locale(){
          return this.$store.getters.getLocale;
      },
      specialTemplate(){
          return this.$store.getters.getSpecialTemplate;
      }
    },
  }
</script>